import { dateFormat } from 'design-system';
import PricingRequestDriver from '../subEntities/PricingRequestDriver';
import CustomerItem from '../../helperTypes/CustomerItem';

import calculateFouls from './calculateFouls';

const { digestDateForBackend } = dateFormat;

type PartialPricingRequestCustomer = {
  firstName: string;
  lastName: string;
  gender: string;
  birthday: string;
  idType: string;
  idNumber: string;
};

/**
 * Returns a customer compatible with the pricing/creation request
 *
 * @param customerItem - The source driver item
 */
export default function makeRequestCustomer(
  customerItem: CustomerItem,
): PricingRequestDriver {
  let usedPartialData: PartialPricingRequestCustomer;
  if (customerItem.driverAndCustomerAreDifferent) {
    usedPartialData = {
      firstName: customerItem.driverFirstName,
      lastName: customerItem.driverLastName,
      gender: customerItem.driverGender,
      idType: customerItem.driverIdType,
      idNumber: customerItem.driverIdNumber,
      birthday: digestDateForBackend(customerItem.driverBirthday),
    };
  } else {
    usedPartialData = {
      firstName: customerItem.firstName,
      lastName: customerItem.lastName,
      gender: customerItem.gender,
      birthday: digestDateForBackend(customerItem.birthday),
      idType: '',
      idNumber: '',
    };
  }

  return {
    ...usedPartialData,
    foulsQty: calculateFouls(customerItem).toString(),
    alcoholicBreath: customerItem.alcoholBreath.toString() === '2',
    transitZone: customerItem.transitZone,

    /** Hard Coded data */
    transitTime: '1', // ¯\_(ツ)_/¯
    nationality: '1', // Panama
    civilStatus: '2', // Single
  };
}
